import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import ZoneMap from './pages/ZoneMap';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import Article from './pages/Article';
import Integrations from './pages/Integrations';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import StatePage from './pages/StatePage';
import CompareIndex from './pages/CompareIndex';
import ComparePage from './pages/ComparePage';
import Book from './pages/Book';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';
import { Toaster } from './components/ui/sonner';
import { captureAttribution } from './lib/analytics';
import { initConsentMode } from './lib/consent';

function App() {
  // Persist UTMs / click IDs on first arrival so any later form submission
  // can attach the original ad source — even if the user clicks around for
  // a while before converting.
  useEffect(() => {
    captureAttribution();
    // Sync any returning consent choice to gtag immediately on mount.
    initConsentMode();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/zones" element={<ZoneMap />} />
          <Route path="/zones/:slug" element={<StatePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Article />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/compare" element={<CompareIndex />} />
          <Route path="/compare/:slug" element={<ComparePage />} />
          <Route path="/book" element={<Book />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
